(() => {
  const root = document.documentElement;
  root.classList.add('has-scroll-reveal');

  const init = () => {
    const sections = [...document.querySelectorAll('#MainContent > .shopify-section')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Keep native/GSAP carousels untouched. Only editorial, non-interactive images
       receive the scroll-linked treatment so motion systems never compete. */
    document.querySelectorAll('#MainContent img').forEach((image) => {
      if (image.closest('[data-hero-slide], [data-media-carousel], [data-aroma-story], [data-product-gallery], .product-gallery, .thumbnail-list')) return;
      if (image.matches('.hero-object, .hero-ingredient, [data-disable-scroll-reveal]')) return;
      image.classList.add('premium-image-reveal');
    });

    if (reducedMotion || !('IntersectionObserver' in window)) {
      sections.forEach((section) => section.classList.add('reveal-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('reveal-visible', entry.isIntersecting);
      });
    }, {
      threshold: 0.01,
      rootMargin: '0px'
    });

    sections.forEach((section) => {
      section.classList.add('reveal-ready');
      observer.observe(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!section || !section.classList.contains('shopify-section')) return;
    section.classList.add('reveal-ready', 'reveal-visible');
    section.querySelectorAll('img').forEach((image) => {
      if (image.closest('[data-hero-slide], [data-media-carousel], [data-aroma-story], [data-product-gallery], .product-gallery, .thumbnail-list')) return;
      if (!image.matches('.hero-object, .hero-ingredient, [data-disable-scroll-reveal]')) image.classList.add('premium-image-reveal');
    });
  });
})();
